// extracted by mini-css-extract-plugin
module.exports = {"points":"Counter_points__gXvPo"};